<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <employee-profile-card :employee-uid="employee.employee_uid" />

          <employee-profile-container-view
            :employee-uid="employee.employee_uid"
            :user-uid="user.user_uid"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      EmployeeProfileCard: () => import('@/components/hris/employee/ProfileCard'),
      EmployeeProfileContainerView: () => import('@/components/hris/employee/profile/ContainerView'),
    },

    metaInfo () {
      return {
        title: 'My e-Profile',
      }
    },
    computed: {  
      ...mapState({ user: 'currentUser', employee: 'currentEmployee', person: 'currentPerson' }),
    },
    created () {
      this.$store.dispatch('getCurrentUser')
      this.$store.state.isMyProfile = true
    },
  }
</script>

<style>
  .ct-square:before{
    content:unset !important;
  }
</style>
